<div
    class="w-100 custom-tree-view"
    appClickOutside
    (clickOutside)="showTree = false"
>
    <mat-form-field appearance="outline" class="w-100">
        <mat-label>Select stores</mat-label>
        <input
            matInput
            placeholder="Select from stores"
            (focus)="showTree = true"
            (click)="showTree = true"
            [readonly]="true"
            [value]="placeHolder"
        />
    </mat-form-field>

    <div
        class="w-100 bg-white position-relative py-2 tree-wrapper"
        *ngIf="dropdown?.length > 0 && showTree"
    >
        <mat-checkbox
            [checked]="isCheckedSelectAll"
            (change)="selectAll($event)"
            >Select ALL</mat-checkbox
        >

        <div class="bg-white box-shadow px-4 py-2 tree-inner">
            <div *ngFor="let data of dropdown; index as i">
                <div class="d-flex align-items-center gap-x-2">
                    <mat-icon
                        class="cursor-pointer"
                        (click)="
                            showIndex === i ? (showIndex = -1) : (showIndex = i)
                        "
                        *ngIf="data?.children && data?.children.length > 0"
                    >
                        {{
                            showIndex === i
                                ? "keyboard_arrow_down"
                                : "chevron_right"
                        }}
                    </mat-icon>
                    <mat-checkbox
                        [value]="data?.value"
                        [checked]="data?.isSelected"
                        [indeterminate]="partiallyComplete(data, i)"
                        (change)="onParentChange($event, i)"
                    >
                        {{ data.item }}
                    </mat-checkbox>
                </div>
                <div class="sub-tree py-2 px-4" *ngIf="showIndex === i">
                    <ng-container
                        *ngFor="
                            let childData of data?.children;
                            index as childIndex
                        "
                    >
                        <mat-checkbox
                            [value]="childData?.value"
                            [checked]="childData?.isSelected"
                            (change)="
                                onChildChange(
                                    $event,
                                    i,
                                    childIndex,
                                    childData,
                                    data?.value
                                )
                            "
                        >
                            {{ childData.item }}
                        </mat-checkbox>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
